var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useKushkiJsContext } from "../../context/useKushkiJsContext";
import { has3DSActive, is3dsValid } from "../../utils/3ds-utils";
var useValidate3DS = function () {
    var _a = useKushkiJsContext(), request3DS = _a.request3DS, requestSecureServiceValidation = _a.requestSecureServiceValidation;
    var validatePayment = function (secureServiceId) { return __awaiter(void 0, void 0, void 0, function () {
        var otpRequest, secureValidationResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    otpRequest = {
                        secureServiceId: secureServiceId,
                        otpValue: "",
                    };
                    return [4 /*yield*/, requestSecureServiceValidation(otpRequest)];
                case 1:
                    secureValidationResponse = _a.sent();
                    return [2 /*return*/, is3dsValid(secureValidationResponse)];
            }
        });
    }); };
    var validate3DS = function (tokenResponse) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request3DS({
                        secureId: tokenResponse.secureId,
                        security: __assign(__assign({}, tokenResponse.security), { authRequired: tokenResponse.security.authRequired }),
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var validate3DSFlow = function (tokenResponse, onSuccess) { return __awaiter(void 0, void 0, void 0, function () {
        var response, is3DSSuccesfull;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!has3DSActive(tokenResponse)) return [3 /*break*/, 5];
                    return [4 /*yield*/, validate3DS(tokenResponse)];
                case 1:
                    response = _a.sent();
                    if (!response.isValid) return [3 /*break*/, 4];
                    return [4 /*yield*/, validatePayment(tokenResponse.secureId)];
                case 2:
                    is3DSSuccesfull = _a.sent();
                    if (!is3DSSuccesfull) return [3 /*break*/, 4];
                    return [4 /*yield*/, onSuccess()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, onSuccess()];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return {
        validate3DSFlow: validate3DSFlow,
    };
};
export { useValidate3DS };
